<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Atenciones</h4>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de citas"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Atenciones">
  <AyudaAtencion />
</Modal>
    <hr>

    <!-- DataTable -->
    <DataTable
      :data="atencions"
      :columns="columnas"
      idField="idAtencion"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarEditar="false"
      :mostrarVer="true"
      :mostrarEliminar="false"
      mensajeVacio="No hay atenciones disponibles."
      @refresh="fetchAtenciones()"
      @info="row => abrirModalEditar(row.idAtencion)"
      @view="row => abrirEditar(row.idAtencion)"
    >
  <template #acciones-extra>
    <div class="col-auto">
      <button type="button"
              class="btn btn-info btn-sm d-flex align-items-center gap-1"
              @click.prevent="getAtencionesPorMedico()"
              title="Atenciones pendientes">
        <span class="material-symbols-outlined" style="font-size:16px">pending_actions</span>
        Pendientes
      </button>
    </div>
  </template>
      <!-- Celda: Fecha -->
      <template #cell-fechaCita="{ row }">
        {{ getFormattedDate(row.fechaCita) }}
      </template>

      <!-- Celda: Estado con color -->
      <template #cell-estadoAtencion="{ row }">
        <span class="badge-estado" :class="getClassForEstadoAtencion(row.estadoAtencion)">
          {{ row.estadoAtencion }}
        </span>
      </template>

      <template #acciones-fila="{ row }">
        <select class="form-select form-select-sm"
                @change="handleAction($event, row.idAtencion)"
                @click.stop>
          <option disabled selected>Seleccione...</option>
          <option value="resumen">Resumen</option>
          <option value="detalles">Detalles</option>
          <option value="indicaciones">Indicaciones</option>
          <option value="certificado">Certificado</option>
        </select>
      </template>
    </DataTable>

    <!-- Modal resumen atención -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalAtencionLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalAtencionLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row mb-2" v-for="campo in camposModal" :key="campo.label">
              <div class="col-3">
                <label class="fw-bold">{{ campo.label }}</label>
              </div>
              <div class="col-9">
                <span class="form-control-plaintext">{{ campo.valor }}</span>
              </div>
            </div>
            <!-- Fila doble: fechas y horas -->
            <div class="row mb-2">
              <div class="col-3"><label class="fw-bold">Fecha Cita</label></div>
              <div class="col-3"><span class="form-control-plaintext">{{ getFormattedDate(datoAtencion.fechaCita) }}</span></div>
              <div class="col-3"><label class="fw-bold">Estado</label></div>
              <div class="col-3">
                <span class="badge-estado form-control-plaintext"
                      :class="getClassForEstadoAtencion(datoAtencion.estadoAtencion)">
                  {{ datoAtencion.estadoAtencion }}
                </span>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-3"><label class="fw-bold">Hora Desde</label></div>
              <div class="col-3"><span class="form-control-plaintext">{{ datoAtencion.horaDesde }}</span></div>
              <div class="col-3"><label class="fw-bold">Hora Hasta</label></div>
              <div class="col-3"><span class="form-control-plaintext">{{ datoAtencion.horaHasta }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout        from '@/components/Layout.vue'
import Footer        from '@/components/Footer.vue'
import AyudaAtencion from '@/views/ayuda/AyudaAtencion.vue'
import DataTable     from '@/components/DataTable.vue'
import { decodificarGenero } from '@/modules/decode.js'
import dateFormat    from '@/modules/dateFormat.js'
import api           from '@/services/api'
import { openModal } from '@/modules/modalHelper.js'
import swal2         from 'sweetalert2'

export default {
  name: 'Atenciones',
  components: { Layout, Footer, AyudaAtencion, DataTable },

  data() {
    return {
      atencions:        [],
      datoAtencion:     {},
      titulo:           '',
      modalWindow:      true,
      showModalHelp:    false,
      p_idEmpresa:      0,
      p_idMedico:       0,

      // Columnas para DataTable
      columnas: [
        { field: 'numero',            label: 'Núm.' },
        { field: 'fechaCita',         label: 'Fecha Cita' },
        { field: 'horaDesde',         label: 'Hora' },
        { field: 'documentoPaciente', label: 'Cédula' },
        { field: 'nombrePaciente',    label: 'Nombre Paciente' },
        {
          field: 'nombreEspecialidad',
          label: 'Especialidad',
          filterType: 'select',
          filterOptions: [],
        },
        {
          field: 'estadoAtencion',
          label: 'Estado',
          filterType: 'select',
          filterOptions: [
            'PENDIENTE',
            'PROCESO',
            'FINALIZADA',
            'PLANILLA GENERADA',
            'FACTURADA',
          ],
        },
      ],
    }
  },

  computed: {
    camposModal() {
      const d = this.datoAtencion
      return [
        { label: 'Número',      valor: d.numero },
        { label: 'Paciente',    valor: d.nombrePaciente },
        { label: 'Documento',   valor: d.documentoPaciente },
        { label: 'Sexo',        valor: this.descGenero(d.sexoPaciente) },
        { label: 'Edad',        valor: d.edadPaciente },
        { label: 'Médico',      valor: d.nombreMedico },
        { label: 'Especialidad',valor: d.nombreEspecialidad },
        { label: 'Motivo',      valor: d.motivo },
        { label: 'Id. Atención',valor: d.idAtencion },
      ]
    },
    opcionesEspecialidad() {
      const set = new Set(this.atencions.map(a => a.nombreEspecialidad).filter(Boolean))
      return [...set].sort()
    },
  },

  watch: {
    opcionesEspecialidad(vals) {
      const col = this.columnas.find(c => c.field === 'nombreEspecialidad')
      if (col) col.filterOptions = vals
    },
  },

  mounted() {
    this.p_idEmpresa = window.sessionStorage.getItem('idEmpresa')
    this.p_idMedico  = window.sessionStorage.getItem('idMedico')
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchAtenciones()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    descGenero(genero) {
      return decodificarGenero(genero)
    },

    getAtencionesPorMedico() {
      const hoy   = new Date()
      const fecha = hoy.toISOString().slice(0, 10)
      api.get('/vwatencions/por-fecha-medico', {
        params: {
          idMedico:   this.p_idMedico,
          fechaDesde: fecha,
          fechaHasta: fecha,
        },
      })
      .then(response => { this.atencions = response.data.reverse() })
      .catch(error   => {
        console.error('Error al obtener atenciones:', error)
        swal2.fire('Error', 'No se encontraron datos con los criterios proporcionados.', 'error')
      })
    },

    // Método centralizado de carga
    fetchAtenciones() {
      api.get(`/vwatencions/idempresa/${this.p_idEmpresa}`)
        .then(response  => { this.atencions = response.data.reverse() })
        .catch(error    => console.error('Error al obtener atenciones:', error))
    },

    // Acciones del select por fila
    handleAction(event, idAtencion) {
      const action = event.target.value
      if      (action === 'resumen')      this.abrirModalEditar(idAtencion)
      else if (action === 'detalles')     this.abrirEditar(idAtencion)
      else if (action === 'indicaciones') this.abrirIndicacionesPDF(idAtencion)
      else if (action === 'certificado')  this.abrirCertificadoPDF(idAtencion)
      event.target.value = 'Seleccione...'
    },

    abrirModalEditar(idAtencion) {
      this.modalWindow = true
      if (idAtencion) {
        api.get(`/vwatencions/${idAtencion}`).then(resp => { this.datoAtencion = resp.data })
      }
      openModal('ventanaModal')
      this.titulo = 'Resumen Atención'
    },

    abrirEditar(idAtencion) {
      if (idAtencion) this.$router.push(`/atencionform/${idAtencion}`)
    },

    abrirIndicacionesPDF(idAtencion) {
      window.open(`/api/v1/reportes/pdf/1/${idAtencion}`, '_blank')
    },

    abrirCertificadoPDF(idAtencion) {
      window.open(`/api/v1/reportes/pdf/2/${idAtencion}`, '_blank')
    },

    getClassForEstadoAtencion(estado) {
      return {
        'PENDIENTE':         'pendiente',
        'PROCESO':           'proceso',
        'FINALIZADA':        'finalizada',
        'PLANILLA GENERADA': 'planilla-generada',
        'FACTURADA':         'facturada',
      }[estado] || ''
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>

<style scoped>
/*  Barra de búsqueda responsive  */
.busqueda-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}

.busqueda-campo {
  display: flex;
  flex-direction: column;
  min-width: 140px;
  flex: 1;
}
.busqueda-campo--sm { flex: 0 1 140px; }
.busqueda-campo--lg { flex: 2 1 220px; }

.busqueda-bar .form-label {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 3px;
  color: #6c757d;
}

.btn-icono {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  flex-shrink: 0;
}

/* Móvil: apilar todo */
@media (max-width: 576px) {
  .busqueda-campo,
  .busqueda-campo--sm,
  .busqueda-campo--lg {
    flex: 1 1 100%;
  }
  .btn-icono { width: 100%; }
}
</style>